import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ActivatedRoute } from '@angular/router';
import { ApiUrls } from '../../apiRouts';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-member-details',
  templateUrl: './member-details.component.html',
  styleUrl: './member-details.component.scss'
})
export class MemberDetailsComponent {
  user_id: any;
  MemberData: any;
  familyMemberList: any;
  fileToUpload: any;
  imageUrl: any;
  imageUrlApi : any;
  baseUrl = environment.imageURL;
  
  constructor(private location: Location, private mainService: MainService,
    private route: ActivatedRoute) {
      this.imageUrl = 'assets/img/user_.jpg';
     }

  goBackToPrevPage(): void {
    this.location.back();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.user_id = params['id'];
    })
    this.getUserDetails();
  }

  getUserDetails() {
    this.mainService.getApi(ApiUrls.userList + this.user_id).subscribe((res: any) => {
      if (res.status == 1 && res.user.length > 0) {
        this.MemberData = res.user;
        this.imageUrlApi = res.user[0].image;        
        
        this.getFamilyInformation();
        this.MemberData = res.user.map((user: any) => {
          const dob = new Date(user.dob);
          const today = new Date();
          let age = today.getFullYear() - dob.getFullYear();
          const monthDiff = today.getMonth() - dob.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
          }
          return { ...user, age };
        });
      }
    });
  }

  getFamilyInformation() {
    let data = {
      user_id: Number(this.user_id),
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      gender: "",
      blood_group: "",
      relation_id: 0,
      image: "", // Assuming 'image' is a property of the member object
      image_file: null,
      main_member_id: Number(this.MemberData[0].main_member_id),
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: "",
      created_by: 0,
      Action: 'USERFAMILYMEMBER'
    };
    this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.familyMemberList = res.user;
      }
    });
  }



}
